/* GemIQ — Black Friday 2026 (Shopify page template, bf26 files). Motion grammar: light switching on.
   Every piece of content comes from the Liquid sections; this file only reads it from the page. */
(() => {
  'use strict';

  // A reload starts at the top so the intro and the pinned scenes measure from a settled page.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // Campaign settings come from the top bar section (bf26lp-topbar); these defaults cover a page without it.
  const cfgEl = document.getElementById('bf26lp-config');
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  const CONFIG = {
    saleEnd: cfg.saleEnd || '2026-11-30T23:59:59-08:00',
    timeZone: cfg.timeZone || 'America/Los_Angeles'
  };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const reduce = designMode || matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const money = n => '$' + Math.round(n).toLocaleString('en-US');
  const pad = n => String(n).padStart(2, '0');
  const SVGNS = 'http://www.w3.org/2000/svg';
  const hasGsap = typeof window.gsap !== 'undefined';

  // The hero's end date follows the sale end (shown in US Pacific, where the sale ends).
  const endDate = new Date(CONFIG.saleEnd).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: CONFIG.timeZone });
  const paintEndLabels = root => $$('[data-end-label]', root).forEach(el => { el.textContent = (el.dataset.prefix || 'Ends') + ' ' + endDate; });
  paintEndLabels(document);

  // In-page links glide to their section (kept out of CSS so ScrollTrigger's measuring jumps stay instant).
  // The destination is re-read every frame, so a refresh mid-glide can't strand it; a pinned scene lands on its start.
  let glide = null;
  const glideTo = el => {
    const doc = document.documentElement;
    const pad = parseFloat(getComputedStyle(doc).scrollPaddingTop) || 0;
    const dest = () => {
      const pin = window.ScrollTrigger && ScrollTrigger.getAll().find(t => t.pin && t.trigger === el);
      const y = pin ? pin.start : el.getBoundingClientRect().top + scrollY - pad;
      return Math.max(0, Math.min(y, doc.scrollHeight - innerHeight));
    };
    if (glide) glide.kill();
    if (reduce || !hasGsap) { scrollTo(0, dest()); return; }
    const from = scrollY, o = { p: 0 };
    glide = gsap.to(o, {
      p: 1, ease: 'power3.inOut', duration: gsap.utils.clamp(.6, 1.6, Math.abs(dest() - from) / 3500),
      onUpdate: () => scrollTo(0, from + (dest() - from) * o.p),
      onComplete: () => { glide = null; }
    });
  };
  // the visitor's own scrolling always wins over a glide
  ['wheel', 'touchstart', 'keydown'].forEach(ev => addEventListener(ev, () => { if (glide) { glide.kill(); glide = null; } }, { passive: true }));
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const id = a.getAttribute('href').slice(1);
    const target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    glideTo(target);
    history.pushState(null, '', '#' + id);
  });

  /* ---------- countdown + LED ring clock ---------- */
  const end = new Date(CONFIG.saleEnd).getTime();
  function buildRing(root) {
    $$('.ring', root).forEach(ring => {
      if (ring.querySelector('.ring__led')) return;
      for (let i = 0; i < 12; i++) {
        const a = (i / 12) * Math.PI * 2;
        const led = document.createElement('span');
        led.className = 'ring__led';
        led.style.left = (50 + 44 * Math.sin(a)) + '%';
        led.style.top = (50 - 44 * Math.cos(a)) + '%';
        led.style.transform = `rotate(${i * 30}deg)`;
        ring.appendChild(led);
      }
    });
  }
  buildRing(document);
  const leds = $$('.ring__led');
  let ringLive = reduce || !hasGsap;
  function tick() {
    const ms = Math.max(0, end - Date.now());
    const t = Math.floor(ms / 1000);
    const d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    $$('[data-countdown]').forEach(c => {
      const set = (sel, v) => { const el = c.querySelector(sel); if (el && el.textContent !== v) el.textContent = v; };
      set('[data-d]', pad(d)); set('[data-h]', pad(h)); set('[data-m]', pad(m)); set('[data-s]', pad(s));
    });
    // The ring drains: one LED for every five seconds left in the current minute.
    const ringLeds = $$('.ring__led');
    if (ringLive && ringLeds.length) {
      const lit = ms > 0 ? Math.floor(s / 5) + 1 : 0;
      ringLeds.forEach((l, i) => { l.classList.toggle('on', i < lit); l.classList.toggle('now', i === lit - 1); });
    }
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- hero wall of reels ---------- */
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
  function makeTile({ handle, poster, video }) {
    const el = document.createElement('div');
    el.className = 'tile';
    if (video) el.dataset.video = video;
    el.innerHTML = `<img src="${esc(poster)}" alt="" decoding="async" loading="lazy" width="540" height="960"><span class="tile__dim"></span><span class="tile__flash"></span>${handle ? `<span class="tile__who">@${esc(handle)}</span>` : ''}<svg class="tile__heart" aria-hidden="true"><use href="#i-heart"/></svg>`;
    return el;
  }
  function buildWall(root = document) {
    const plane = $('.wall__plane', root);
    const data = $('[data-wall-tiles]', root);
    const REELS = data ? JSON.parse(data.textContent).filter(t => t.poster) : [];
    if (!plane || !REELS.length) return { tiles: [], tracks: [] };
    plane.textContent = '';
    const w = innerWidth;
    const cols = w < 560 ? 7 : w < 900 ? 8 : 11;
    const per = 4;
    const tiles = [], tracks = [];
    for (let c = 0; c < cols; c++) {
      const col = document.createElement('div');
      col.className = 'wall__col';
      const track = document.createElement('div');
      track.className = 'wall__track';
      const set = [];
      for (let i = 0; i < per; i++) set.push(REELS[(c * 7 + i * 3) % REELS.length]);
      for (let k = 0; k < 2; k++) set.forEach(r => { const t = makeTile(r); track.appendChild(t); tiles.push(t); });
      col.appendChild(track);
      plane.appendChild(col);
      tracks.push(track);
    }
    return { tiles, tracks };
  }
  const wall = buildWall();
  if (designMode) { const wallEl = $('.wall'); if (wallEl) wallEl.classList.add('is-static'); }

  // Hover a reel in the wall: it lights up, plays, and its column slows down.
  function bindTileHover(drift) {
    if (!canHover) return;
    wall.tiles.forEach(tile => {
      const track = tile.parentElement;
      const tw = drift && drift.get(track);
      tile.addEventListener('pointerenter', () => {
        if (!tile.dataset.video) return;
        if (tw) gsap.to(tw, { timeScale: 0, duration: .8, ease: 'power2.out', overwrite: true });
        let v = tile.querySelector('video');
        if (!v) {
          v = document.createElement('video');
          v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
          v.src = tile.dataset.video;
          v.addEventListener('playing', () => tile.classList.add('is-playing'));
          tile.insertBefore(v, tile.querySelector('.tile__dim'));
        }
        v.play().catch(() => {});
      });
      tile.addEventListener('pointerleave', () => {
        if (tw) gsap.to(tw, { timeScale: 1, duration: 1.2, ease: 'power2.inOut', overwrite: true });
        const v = tile.querySelector('video');
        if (v) { v.pause(); tile.classList.remove('is-playing'); }
      });
    });
  }

  /* ---------- hearts ---------- */
  function burstHearts(container, n, ox, oy, spread = 1) {
    if (!hasGsap || reduce || !container) return;
    for (let i = 0; i < n; i++) {
      const h = document.createElementNS(SVGNS, 'svg');
      h.setAttribute('class', 'heart-fly');
      h.setAttribute('aria-hidden', 'true');
      const use = document.createElementNS(SVGNS, 'use');
      use.setAttribute('href', '#i-heart');
      h.appendChild(use);
      container.appendChild(h);
      gsap.set(h, { left: ox, top: oy, xPercent: -50, yPercent: -50, scale: 0, opacity: 1 });
      gsap.timeline({ delay: i * .11, onComplete: () => h.remove() })
        .to(h, { scale: gsap.utils.random(.65, 1.15), duration: .35, ease: 'back.out(2.4)' })
        .to(h, { y: gsap.utils.random(-210, -130) * spread, x: gsap.utils.random(-46, 40) * spread, rotation: gsap.utils.random(-24, 24), duration: 1.7, ease: 'power1.out' }, 0)
        .to(h, { opacity: 0, duration: .7, ease: 'power1.in' }, 1);
    }
  }

  /* ---------- real footage switcher ---------- */
  // The source footage shows both phones on a white set; only the two camera screens are drawn onto the page.
  const SCREEN = { y: 440, w: 354, h: 405, a: 94, b: 514 };
  function setupDiff(root = document) {
    const sec = $('[data-diff]', root);
    const box = sec && $('[data-diff-box]', sec);
    if (!sec || !box || sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const COMPARE = {};
    $$('.piece', sec).forEach(t => { COMPARE[t.dataset.piece] = { name: t.dataset.name, gem: t.dataset.gem, video: t.dataset.video, a: t.dataset.a, b: t.dataset.b }; });
    const vid = $('[data-diff-video]', box);
    const imgA = $('[data-diff-a]', box), imgB = $('[data-diff-b]', box);
    const ctxA = $('[data-diff-ca]', box).getContext('2d');
    const ctxB = $('[data-diff-cb]', box).getContext('2d');
    const name = $('[data-piece-name]', sec);
    const tabs = $$('.piece', sec);
    let current = tabs.length ? tabs[0].dataset.piece : '';
    if (!current) return;
    let inView = false;
    let raf = 0;
    // Optional auto-advance through the pieces. It stops for good once the shopper picks one.
    const every = (+sec.dataset.rotate || 0) * 1000;
    let auto = every > 0 && !reduce && tabs.length > 1;
    let timer = 0;
    const queue = () => {
      clearTimeout(timer);
      if (!auto || !inView) return;
      timer = setTimeout(() => {
        const i = tabs.findIndex(t => t.dataset.piece === current);
        show(tabs[(i + 1) % tabs.length].dataset.piece);
      }, every);
    };
    const takeOver = () => { auto = false; clearTimeout(timer); };
    sec.style.setProperty('--gem', COMPARE[current].gem);
    const draw = () => {
      if (vid.readyState >= 2) {
        ctxA.drawImage(vid, SCREEN.a, SCREEN.y, SCREEN.w, SCREEN.h, 0, 0, SCREEN.w, SCREEN.h);
        ctxB.drawImage(vid, SCREEN.b, SCREEN.y, SCREEN.w, SCREEN.h, 0, 0, SCREEN.w, SCREEN.h);
        box.classList.add('is-playing');
      }
      if (!vid.paused) raf = vid.requestVideoFrameCallback ? vid.requestVideoFrameCallback(draw) : requestAnimationFrame(draw);
    };
    // Count each piece's time from when its footage is actually on screen.
    vid.addEventListener('playing', () => { cancelAnimationFrame(raf); draw(); queue(); });
    const load = key => {
      const c = COMPARE[key];
      box.classList.remove('is-playing');
      imgA.src = c.a;
      imgB.src = c.b;
      imgA.alt = `${c.name} filmed on an iPhone on its own`;
      imgB.alt = `The same ${c.name.toLowerCase()} filmed on the same iPhone with GemSparkle clipped on`;
      if (c.video) { vid.src = c.video; if (inView) vid.play().catch(() => {}); }
      else vid.removeAttribute('src');
    };
    const show = (key, focus) => {
      if (key === current) return;
      current = key;
      tabs.forEach(t => {
        const on = t.dataset.piece === key;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      name.textContent = COMPARE[key].name;
      sec.style.setProperty('--gem', COMPARE[key].gem);
      if (hasGsap && !reduce) gsap.fromTo(box, { filter: 'brightness(.35)' }, { filter: 'brightness(1)', duration: .9, ease: 'expo.out', clearProps: 'filter' });
      load(key);
      queue();
    };
    tabs.forEach((t, i) => {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', () => { takeOver(); show(t.dataset.piece); });
      t.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        takeOver();
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        show(next.dataset.piece, true);
      });
    });
    const io = new IntersectionObserver(([en]) => {
      inView = en.isIntersecting;
      if (inView) { if (!vid.getAttribute('src')) load(current); if (vid.getAttribute('src')) vid.play().catch(() => {}); queue(); }
      else { vid.pause(); clearTimeout(timer); }
    }, { rootMargin: '120px 0px' });
    io.observe(box);
  }

  /* ---------- Wall of Love reels ---------- */
  function setupReels(root = document) {
    const wrap = $('[data-reels]', root);
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const sec = wrap.closest('section') || document;
    const track = $('.reels__track', wrap);
    const reels = $$('.reel', wrap);
    let dragged = false;

    const stopAll = except => reels.forEach(r => {
      if (r === except) return;
      const v = $('video', r);
      if (v && !v.paused) v.pause();
      r.classList.remove('is-playing');
    });
    const toggle = reel => {
      const v = $('video', reel);
      if (!reel.dataset.video) return;
      if (!v.getAttribute('src')) {
        v.src = reel.dataset.video;
        v.addEventListener('playing', () => reel.classList.add('is-playing'));
        v.addEventListener('pause', () => reel.classList.remove('is-playing'));
      }
      if (v.paused) { stopAll(reel); v.play().catch(() => {}); }
      else v.pause();
    };
    reels.forEach(reel => {
      $('.reel__play', reel).addEventListener('click', e => { if (dragged) { e.preventDefault(); return; } toggle(reel); });
      const like = $('.like', reel);
      like.addEventListener('click', e => {
        if (dragged) { e.preventDefault(); return; }
        const on = like.getAttribute('aria-pressed') !== 'true';
        like.setAttribute('aria-pressed', on);
        if (on) {
          if (hasGsap && !reduce) gsap.fromTo(like, { scale: .7 }, { scale: 1, duration: .5, ease: 'back.out(3)' });
          burstHearts(reel, 4, 'calc(100% - 34px)', '34px', .7);
        }
      });
    });
    new IntersectionObserver(([en]) => { if (!en.isIntersecting) stopAll(); }).observe(wrap);

    if (!hasGsap || typeof Draggable === 'undefined') { wrap.style.overflowX = 'auto'; return; }
    const bounds = () => ({ minX: Math.min(0, wrap.clientWidth - track.scrollWidth), maxX: 0 });
    const drag = Draggable.create(track, {
      type: 'x',
      bounds: bounds(),
      inertia: true,
      edgeResistance: .85,
      dragClickables: true,
      minimumMovement: 6,
      onDragStart: () => { dragged = true; },
      onDragEnd: () => { setTimeout(() => { dragged = false; }, 60); }
    })[0];
    addEventListener('resize', () => { drag.applyBounds(bounds()); });
    const step = dir => {
      const b = bounds();
      if (!reels.length) return;
    const card = reels[0].getBoundingClientRect().width + 16;
      const x = gsap.utils.clamp(b.minX, b.maxX, gsap.getProperty(track, 'x') - dir * card * 2);
      gsap.to(track, { x, duration: .9, ease: 'expo.out', onUpdate: () => drag.update() });
    };
    const prev = $('[data-reels-prev]', sec), next = $('[data-reels-next]', sec);
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
  }

  /* ---------- dock ---------- */
  function setupDock() {
    const dock = $('.dock');
    const hero = $('.hero');
    const last = $('.last');
    if (!dock || !hero) return;
    const mini = $('.mini');
    let pastHero = false, atEnd = false, onMini = false;
    const sync = () => dock.classList.toggle('is-on', pastHero && !atEnd && !onMini);
    new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; sync(); }, { threshold: 0 }).observe(hero);
    if (last) new IntersectionObserver(([en]) => { atEnd = en.isIntersecting; sync(); }, { threshold: .25 }).observe(last);
    if (mini) new IntersectionObserver(([en]) => { onMini = en.isIntersecting; sync(); }, { threshold: .2 }).observe(mini);
  }

  // GemSparkle's 13 LEDs, clockwise from 12 o'clock, in % of the square product plate (measured from sparkle-1.webp).
  // bf.css masks the bright plate to these points; --l0 to --l12 on .stage-sq switch each one on.
  const LEDS = [[53.37, 59.3], [57.98, 60.62], [61.33, 64.56], [62.67, 69.88], [61.86, 75.45], [59.23, 79.87], [55.5, 82.62], [51.53, 82.98], [47.75, 81.15], [44.67, 76.94], [43.64, 71.21], [45.05, 65.39], [48.65, 61.09]];
  // The "Lights on" scene's ring: twelve LEDs, the same object as the finale's clock.
  const sparkLeds = [];
  function buildLedrings(root) {
    $$('.ledring', root).forEach(ringEl => {
    if (ringEl.querySelector('.ledring__led')) return;
    for (let i = 0; i < 12; i++) {
      const a = (i / 12) * Math.PI * 2;
      const led = document.createElement('span');
      led.className = 'ledring__led';
      led.style.left = (50 + 44 * Math.sin(a)) + '%';
      led.style.top = (50 - 44 * Math.cos(a)) + '%';
      led.style.transform = `rotate(${i * 30}deg)`;
      led.appendChild(document.createElement('i'));
      ringEl.appendChild(led);
      sparkLeds.push(led);
    }
    });
  }
  const paintLeds = root => $$('.stage-sq__leds', root).forEach(box => {
    box.innerHTML = LEDS.map(([x, y], i) => '<i style="--x:' + x + '%;--y:' + y + '%;opacity:calc(var(--l' + i + ', 1) * var(--gl, .5))"></i>').join('');
  });
  buildLedrings(document);
  paintLeds(document);

  setupDiff();
  setupReels();
  setupDock();

  // Theme editor: a section that is edited re-renders, so rebuild what this file adds to it.
  if (designMode) {
    document.addEventListener('shopify:section:load', e => {
      const root = e.target;
      buildRing(root); buildLedrings(root); paintLeds(root); paintEndLabels(root);
      setupDiff(root); setupReels(root);
      const w = buildWall(root);
      const wallEl = $('.wall', root);
      if (wallEl) wallEl.classList.add('is-static');
      w.tiles.forEach(t => { t.style.opacity = 1; });
      tick();
    });
  }

  /* ================= GSAP ================= */
  if (!hasGsap) {
    const wallEl = $('.wall');
    if (wallEl) wallEl.classList.add('is-static');
    document.documentElement.classList.remove('is-loading');
    return;
  }
  gsap.registerPlugin(ScrollTrigger, SplitText, Draggable, InertiaPlugin);
  gsap.defaults({ ease: 'expo.out' });

  const ledVars = v => Object.fromEntries(LEDS.map((_, i) => ['--l' + i, v]));
  function ledsOn(el, span, ease = 'power2.out') {
    const t = gsap.timeline();
    const step = span / LEDS.length;
    LEDS.forEach((_, i) => t.fromTo(el, { ['--l' + i]: 0 }, { ['--l' + i]: 1, duration: Math.max(.14, step * 2), ease, immediateRender: false }, i * step));
    return t;
  }

  // Slashed price: the old price is cut through and falls away, the Black Friday price lands, the tag swings in.
  function primeDrop(el) {
    if (!el || el.dataset.dropped) return;
    gsap.set($('.drop__old', el), { opacity: 1, '--cut': 0 });
    gsap.set($('.drop__new', el), { opacity: 0 });
    gsap.set($('.price__was', el), { opacity: 0, '--strike': 0 });
    gsap.set($('.tag', el), { rotation: -40, opacity: 0 });
  }
  function dropPrice(el) {
    if (!el || el.dataset.dropped) return;
    el.dataset.dropped = '1';
    gsap.timeline()
      .to($('.drop__old', el), { '--cut': 1, duration: .4, ease: 'power3.inOut' })
      .to($('.drop__old', el), { yPercent: 75, rotation: 8, opacity: 0, duration: .55, ease: 'power2.in' }, '+=.08')
      .fromTo($('.drop__new', el), { yPercent: -60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, ease: 'expo.out' }, '<.22')
      .to($('.price__was', el), { opacity: 1, '--strike': 1, duration: .5, ease: 'power2.out' }, '<.2')
      .to($('.tag', el), { rotation: 0, opacity: 1, duration: 1.6, ease: 'elastic.out(1, .32)' }, '<.05');
  }

  const plane = $('.wall__plane');
  gsap.set(plane, { xPercent: -50, yPercent: -50, rotationX: 22, rotationZ: -9, scale: 1.08, transformOrigin: '50% 50%' });

  // Endless drift of the wall columns, alternating directions.
  const drift = new Map();
  if (!reduce) {
    wall.tracks.forEach((track, i) => {
      const up = i % 2 === 0;
      const tw = gsap.fromTo(track, { yPercent: up ? 0 : -50 }, { yPercent: up ? -50 : 0, duration: 80 + (i % 4) * 16, ease: 'none', repeat: -1 });
      drift.set(track, tw);
    });
    ScrollTrigger.create({
      trigger: '.hero', start: 'top bottom', end: 'bottom top',
      onToggle: self => drift.forEach(tw => (self.isActive ? tw.resume() : tw.pause()))
    });
  }
  bindTileHover(drift);


  /* ---------- the focal moment: lights on ---------- */
  function ignite() {
    if (!$('.hero') || !$('.hero__product')) { document.documentElement.classList.remove('is-loading'); return gsap.timeline(); }
    const product = $('.hero__product');
    const sq = $('.hero__product .stage-sq');
    const base = $('.hero__product .stage-sq__base');
    const bloom = $('.hero__product .bloom');
    const spill = $('.hero__spill');
    const buy = $$('.hero__buy, .hero__trust');
    const deal = $('.hero__deal');
    const tag = $('.hero__deal .tag');
    const was = $('.hero__deal .price__was');
    const price = $('.hero__now');
    const lead = $$('.hero__sub, .hero__when');
    const split = SplitText.create('.hero__title', { type: 'words', wordsClass: 'hw' });

    gsap.set(split.words, { opacity: .05, filter: 'blur(8px)' });
    gsap.set(base, { filter: 'brightness(.08)' });
    gsap.set(sq, { ...ledVars(0), '--gl': 1 });
    gsap.set(price, { '--glow': 0 });
    gsap.set(spill, { opacity: 0 });
    gsap.set(buy, { opacity: 0, y: 16 });
    gsap.set(lead, { opacity: 0, y: 10 });
    gsap.set(deal, { opacity: 0, x: -18 });
    gsap.set(was, { '--strike': 0 });
    gsap.set(tag, { rotation: -40, opacity: 0 });
    gsap.set(wall.tiles, { opacity: 0 });
    document.documentElement.classList.remove('is-loading');

    const tl = gsap.timeline({ delay: .15 });
    tl.to(split.words, { opacity: 1, filter: 'blur(0px)', duration: 1, stagger: .065, ease: 'power2.out' }, 0)
      // GemSparkle's LEDs switch on one by one around the ring
      .to(lead, { opacity: 1, y: 0, duration: .7, stagger: .14, ease: 'power2.out' }, .5)
      .add(ledsOn(sq, 1.2), .35)
      // the flash: the product is lit, its light spills onto the wall, the price starts to glow
      .to(bloom, { opacity: 1, scale: 1.3, duration: .32, ease: 'power2.out' }, 1.6)
      .to(base, { filter: 'brightness(1)', duration: 1.1, ease: 'power2.out' }, 1.6)
      .to(spill, { opacity: 1, duration: 1.4, ease: 'power2.out' }, 1.6)
      // the deal steps out of the light: the old price is struck through, then $299 glows
      .to(deal, { opacity: 1, x: 0, duration: .8, ease: 'power3.out' }, 1.6)
      .to(was, { '--strike': 1, duration: .45, ease: 'power2.inOut' }, 1.95)
      .to(price, { '--glow': 1, duration: 1.4, ease: 'power2.out' }, 2.05)
      .to(bloom, { opacity: .35, scale: 1, duration: 1.4, ease: 'power2.out' }, 1.92)
      .to(sq, { '--gl': .5, duration: 1.2, ease: 'power2.out' }, 2)
      .to($('.hero__product .stage-sq__ring'), { opacity: 0, duration: 1, ease: 'power1.out' }, 2)
      .to(buy, { opacity: 1, y: 0, duration: .9, stagger: .1 }, 1.45)
      .to(tag, { rotation: 0, opacity: 1, duration: 1.6, ease: 'elastic.out(1, .32)' }, 2.25)
      .add(() => rippleTiles(product), .9);
    return tl;
  }

  // Tiles switch on in a wave that spreads out from the product.
  function rippleTiles(origin) {
    const o = origin.getBoundingClientRect();
    const ox = o.left + o.width / 2, oy = o.top + o.height / 2;
    const vw = innerWidth, vh = innerHeight;
    let max = 1;
    const items = wall.tiles.map(t => {
      const r = t.getBoundingClientRect();
      const visible = r.right > 0 && r.left < vw && r.bottom > 0 && r.top < vh;
      const d = Math.hypot(r.left + r.width / 2 - ox, r.top + r.height / 2 - oy);
      if (visible) max = Math.max(max, d);
      return { t, d, visible };
    });
    items.forEach(({ t, d, visible }) => {
      if (!visible) { gsap.set(t, { opacity: 1 }); return; }
      const delay = (d / max) * 1.2;
      gsap.to(t, { opacity: 1, duration: .5, delay, ease: 'power2.out' });
      gsap.fromTo(t.querySelector('.tile__flash'), { opacity: 0 }, { keyframes: [{ opacity: .8, duration: .12, ease: 'none' }, { opacity: 0, duration: .9, ease: 'power2.out' }], delay });
    });
  }

  const ready = Promise.race([document.fonts ? document.fonts.ready : Promise.resolve(), new Promise(r => setTimeout(r, 900))]);
  ready.then(() => {
    if (reduce) {
      gsap.set(wall.tiles, { opacity: 1 });
      document.documentElement.classList.remove('is-loading');
    } else {
      ignite();
    }
    initScroll();
    ScrollTrigger.refresh();
  });
  addEventListener('load', () => ScrollTrigger.refresh());

  // Keep pin positions true when late fonts, lazy images or anything else changes the layout above them.
  let refreshTimer = 0;
  const refreshSoon = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(() => ScrollTrigger.refresh(), 160); };
  if (document.fonts) document.fonts.ready.then(refreshSoon);
  $$('img').forEach(img => { if (!img.complete) img.addEventListener('load', refreshSoon, { once: true }); });
  const sizes = new Map();
  const sizeWatch = new ResizeObserver(entries => {
    let changed = false;
    entries.forEach(en => {
      const h = Math.round(en.contentRect.height);
      if (sizes.has(en.target) && sizes.get(en.target) !== h) changed = true;
      sizes.set(en.target, h);
    });
    if (changed) refreshSoon();
  });
  $$('main > *, .bf26lp-topbar-section').forEach(el => sizeWatch.observe(el));

  function initScroll() {
    if (reduce) { ringLive = true; return; }

    // Hero: the wall tilts away as you scroll past.
    gsap.to(plane, {
      rotationX: 40, yPercent: -62, scale: 1, ease: 'none',
      scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: .6 }
    });
    gsap.to('.wall', { opacity: .25, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });

    // Deals: BLACK FRIDAY slides across in two directions as you scroll in.
    const rows = $$('.bf__row');
    if (rows.length === 2) {
      const st = { trigger: '.bf', start: 'top bottom', end: 'bottom top', scrub: .4 };
      gsap.fromTo(rows[0], { xPercent: 0 }, { xPercent: -26, ease: 'none', scrollTrigger: st });
      gsap.fromTo(rows[1], { xPercent: -26 }, { xPercent: 0, ease: 'none', scrollTrigger: { ...st } });
    }

    // Every deal price outside the pinned Mini scene gets slashed when it arrives.
    $$('.drop').filter(d => !d.closest('.mini')).forEach(d => {
      primeDrop(d);
      ScrollTrigger.create({ trigger: d, start: 'top 85%', once: true, onEnter: () => dropPrice(d) });
    });

    // GemSparkle deal stage: the LEDs relight when the panel arrives.
    const dSq = $('.dhero .stage-sq');
    if (dSq) {
      const dBase = $('.dhero .stage-sq__base');
      gsap.set(dSq, { ...ledVars(0), '--gl': 1 });
      gsap.set(dBase, { filter: 'brightness(.12)' });
      gsap.timeline({ scrollTrigger: { trigger: '.dhero', start: 'top 70%', once: true } })
        .add(ledsOn(dSq, 1.1))
        .to(dBase, { filter: 'brightness(1)', duration: 1, ease: 'power2.out' }, '-=.1')
        .fromTo('.dhero .bloom', { opacity: 0, scale: .7 }, { opacity: .35, scale: 1, duration: 1.2, ease: 'power2.out' }, '<')
        .add(() => burstHearts($('.dhero .hearts'), 2, '54%', '42%', .8), '<.3')
        .to(dSq, { '--gl': .5, duration: 1, ease: 'power2.out' }, '<.4')
        .to('.dhero .stage-sq__ring', { opacity: 0, duration: 1 }, '<');
    }

    const mm = gsap.matchMedia();
    mm.add({ desktop: '(min-width: 901px)', mobile: '(max-width: 900px)' }, ctx => {
      const { desktop } = ctx.conditions;
      spark(desktop);
      mini(desktop);
    });

    // 3-pack: each line switches on in turn as you scroll.
    const trioLines = $$('.trio__lines span');
    gsap.set(trioLines, { color: '#3a4046' });
    gsap.set($$('.trio__lines .led'), { opacity: .15 });
    const ttl = gsap.timeline({ scrollTrigger: { trigger: '.trio__lines', start: 'top 78%', end: 'bottom 45%', scrub: .5 } });
    trioLines.forEach((line, i) => {
      ttl.to(line, { color: '#f4f5f6', duration: 1, ease: 'power2.out' }, i)
        .to(line.querySelector('.led'), { opacity: 1, duration: .3, ease: 'none' }, i);
    });
    gsap.fromTo('.trio__img img', { filter: 'brightness(.15)' }, { filter: 'brightness(1)', ease: 'none', scrollTrigger: { trigger: '.trio__img', start: 'top 85%', end: 'center 55%', scrub: true } });

    // Wall of Love: the reels switch on one after another as the row arrives.
    const reelMedia = $$('.reel__media');
    gsap.set(reelMedia, { opacity: .1 });
    ScrollTrigger.create({
      trigger: '.reels', start: 'top 82%', once: true,
      onEnter: () => reelMedia.forEach((m, i) => gsap.fromTo(m, { opacity: .1, filter: 'brightness(1)' }, {
        keyframes: [{ opacity: 1, filter: 'brightness(1.9)', duration: .16, ease: 'none' }, { filter: 'brightness(1)', duration: .8, ease: 'power2.out' }],
        delay: i * .07, clearProps: 'filter'
      }))
    });

    // Wall of Love: the numbers count up once.
    $$('[data-count]').forEach(el => {
      const to = +el.dataset.count;
      const o = { v: 0 };
      el.textContent = '0';
      ScrollTrigger.create({
        trigger: el, start: 'top 85%', once: true,
        onEnter: () => {
          gsap.to(o, { v: to, duration: 1.8, ease: 'expo.out', onUpdate: () => { el.textContent = Math.round(o.v).toLocaleString('en-US'); } });
          burstHearts($('.love__title'), 3, '96%', '70%', .8);
        }
      });
    });

    // Compare: savings bars fill to scale.
    gsap.from('.save__bar i', { scaleX: 0, duration: 1.2, stagger: .12, ease: 'expo.out', scrollTrigger: { trigger: '.ctable', start: 'top 75%', once: true } });

    // Final ring: the LEDs chase on, then the ring becomes the live clock.
    gsap.set(leds, { opacity: .25 });
    ScrollTrigger.create({
      trigger: '.last', start: 'top 70%', once: true,
      onEnter: () => {
        leds.forEach(l => l.classList.add('on'));
        gsap.to(leds, {
          opacity: 1, duration: .25, stagger: .07, ease: 'none',
          onComplete: () => { ringLive = true; tick(); }
        });
      }
    });
  }

  function spark(desktop) {
    const sec = $('.spark');
    const flash = $('.ledring__flash');
    const tag = $('.spark__center .tag');
    const num = $('.spark__num');
    const beats = $$('.spark__beats li');
    if (!sec || !num) return;
    const from = +num.dataset.from || 449, to = +num.dataset.to || 299;
    const o = { v: from };
    const render = () => { num.textContent = money(o.v); };
    gsap.set(sparkLeds, { '--on': 0 });
    gsap.set(flash, { opacity: 0, scale: .8 });
    gsap.set(tag, { opacity: 0, rotation: -30 });
    render();

    const tl = gsap.timeline({
      defaults: { ease: 'none' },
      onUpdate() {
        const idx = Math.min(beats.length - 1, Math.floor(this.time() / .75));
        beats.forEach((b, j) => b.classList.toggle('is-on', j <= idx));
      },
      scrollTrigger: desktop
        ? { trigger: sec, start: 'top top', end: '+=150%', pin: '.spark__pin', scrub: .7, anticipatePin: 1 }
        : { trigger: sec, start: 'top 65%', toggleActions: 'play none none none' }
    });
    // one LED lights for every step the price falls; when the ring is full, it flashes and the tag lands
    sparkLeds.forEach((led, i) => tl.to(led, { '--on': 1, duration: .22, ease: 'power2.out' }, i * (2.8 / sparkLeds.length)));
    tl.to(o, { v: to, duration: 3, ease: 'power1.inOut', onUpdate: render }, 0)
      .to(flash, { opacity: 1, scale: 1.05, duration: .25, ease: 'power2.out' }, 3)
      .to(flash, { opacity: .45, scale: 1, duration: .8, ease: 'power2.out' }, 3.25)
      .to(tag, { opacity: 1, rotation: 0, duration: .5, ease: 'back.out(2.2)' }, 3.05)
      .to({}, { duration: .4 });
    if (!desktop) tl.duration(3.2);
    return () => { num.textContent = money(to); };
  }

  function mini(desktop) {
    const img = $('.mini__stage img');
    const a = $('.mini__h .a'), b = $('.mini__h .b');
    const feats = $$('.mini__feat');
    const buy = $('.mini__buy');
    const drop = $('.mini .drop');
    if (!img || !$('.mini__h')) return;
    $('.mini__h').classList.add('is-stacked');
    primeDrop(drop);
    if (desktop) {
      gsap.set(img, { scale: .5, filter: 'brightness(.08)' });
      gsap.set(b, { yPercent: 70, opacity: 0 });
      gsap.set(feats, { opacity: 0, x: (i, el) => (el.classList.contains('mini__feat--l') ? -24 : 24), '--draw': 0 });
      gsap.set(buy, { opacity: 0, y: 30 });
      gsap.timeline({ scrollTrigger: { trigger: '.mini', start: 'top top', end: '+=150%', pin: '.mini__pin', scrub: .7, anticipatePin: 1 } })
        .to(img, { scale: 1, filter: 'brightness(1)', duration: 2, ease: 'power2.inOut' }, 0)
        .to(a, { yPercent: -70, opacity: 0, duration: .6, ease: 'power2.in' }, .85)
        .to(b, { yPercent: 0, opacity: 1, duration: .7, ease: 'power2.out' }, 1.15)
        .to(feats, { opacity: 1, x: 0, stagger: .14, duration: .5, ease: 'power2.out' }, 1.5)
        // leader lines draw from each callout to the box
        .to(feats, { '--draw': 1, stagger: .08, duration: .35, ease: 'power2.inOut' }, 1.6)
        .to(buy, { opacity: 1, y: 0, duration: .6, ease: 'power2.out' }, 2.3)
        .call(() => dropPrice(drop), null, 2.75)
        .to({}, { duration: .5 });
    } else {
      gsap.set(b, { opacity: 0 });
      gsap.timeline({ scrollTrigger: { trigger: '.mini__stage', start: 'top 75%', end: 'bottom 60%', scrub: .5 } })
        .fromTo(img, { filter: 'brightness(.1)', scale: .8 }, { filter: 'brightness(1)', scale: 1, ease: 'power2.out', duration: 1 }, 0)
        .to(a, { opacity: 0, duration: .3 }, .5)
        .to(b, { opacity: 1, duration: .3 }, .6);
      ScrollTrigger.create({ trigger: drop, start: 'top 85%', once: true, onEnter: () => dropPrice(drop) });
    }
  }
})();
